import { OrderStatusEnum } from '@/enums/order.enum'

type OrderCollectedSourceType = {
  trip?: { status?: string | null } | string | null
  driver?: { tripStatus?: string | null } | null
  lastStatus?: string | null
}

function getTripStatus(
  trip?: { status?: string | null } | string | null
): string | undefined {
  if (!trip || typeof trip === 'string') {
    return undefined
  }

  return trip.status ?? undefined
}

export function isOrderCompleted(status: string) {
  return (
    status === OrderStatusEnum.DELIVERED ||
    status === OrderStatusEnum.COMPLETED ||
    status === OrderStatusEnum.PICKED ||
    status === OrderStatusEnum.CANCELLED ||
    status === OrderStatusEnum.REJECTED
  )
}

export function isOrderOnGoing(status: string) {
  return (
    status === OrderStatusEnum.CREATED ||
    status === OrderStatusEnum.IN_PROGRESS ||
    status === OrderStatusEnum.READY ||
    status === OrderStatusEnum.COLLECTED ||
    status === OrderStatusEnum.IN_TRANSIT ||
    status === OrderStatusEnum.SCHEDULED
  )
}

function hasProgressedPastCollected(lastStatus?: string | null) {
  return (
    lastStatus === OrderStatusEnum.IN_TRANSIT ||
    isOrderCompleted(lastStatus ?? '')
  )
}

export function isOrderCollected(order: OrderCollectedSourceType) {
  if (hasProgressedPastCollected(order.lastStatus)) {
    return false
  }

  return (
    getTripStatus(order?.trip) === OrderStatusEnum.COLLECTED ||
    order.driver?.tripStatus === OrderStatusEnum.COLLECTED ||
    order.lastStatus === OrderStatusEnum.COLLECTED
  )
}

export function getOrderDisplayStatus(order: OrderCollectedSourceType) {
  if (isOrderCollected(order)) {
    return OrderStatusEnum.COLLECTED
  }

  return order.lastStatus ?? ''
}

export function isOrderReadyOrAfterReady(status: string) {
  return (
    status === OrderStatusEnum.DELIVERED ||
    status === OrderStatusEnum.COMPLETED ||
    status === OrderStatusEnum.READY ||
    status === OrderStatusEnum.IN_TRANSIT
  )
}

export function isOrderBentoInTransit(
  status: string,
  isDeliveryHandlerBento: boolean,
  isSuperAdmin: boolean
) {
  return (
    status === OrderStatusEnum.IN_TRANSIT &&
    isDeliveryHandlerBento &&
    !isSuperAdmin
  )
}

export function isOrderScheduled(status: string) {
  return status === OrderStatusEnum.SCHEDULED
}

export function isOrderCancelledOrRejected(status: string) {
  return (
    status === OrderStatusEnum.CANCELLED ||
    status === OrderStatusEnum.REJECTED
  )
}
